import * as Sentry from "@sentry/react"

/** Mint a fresh UUIDv4 to thread through one outbound API request. */
export function mintRequestId(): string {
  return crypto.randomUUID()
}

/**
 * Tag the active Sentry scope so any Sentry event captured during this request
 * shares the same `request_id` as the matching backend log line.
 */
export function tagRequestId(id: string): void {
  Sentry.getCurrentScope().setTag("request_id", id)
}

/** Header name agreed with the backend (`backend/internal/observability/request_id.go`). */
export const REQUEST_ID_HEADER = "X-Request-Id"
